import { HIDE_MODAL, SET_MODAL } from "../constants/modals";
import { ModalPayload } from "../models/modals";

export const setModal = (data: ModalPayload) => ({
  type: SET_MODAL,
  payload: data,
});

export const hideModal = () => ({
  type: HIDE_MODAL,
});
